import { Button, ButtonGroup, TextField } from "@mui/material";

const FlatComponent = (props) => {
  const { question, multiline, disabled } = props;
  
   console.log(question);
   
  return (
    <>
      {/* <TextField
        id={question._id}
        key={"component" + question._id}
        fullWidth={true}
        minRows={multiline ? 5 : 1}
        multiline={multiline}
        disabled={disabled}
        placeholder={question.tooltip ? question.questiond.tooltip : ""}
        onChange={(event) => {}}
        variant="outlined"
      /> */}

      <ButtonGroup
        fullWidth={true}
        color="dark"
        aria-label="outlined button group"
      >
        {question.answers.map((ans, index) => (
          <Button key={ans.id}>
            <div style={{ color: "#000" }}>{ans.text}</div>
          </Button>
        ))}
      </ButtonGroup>
      {question?.questiond?.helpPage !== undefined && (
        <a href="#">
          <div style={{ width: "100%", textAlign: "right" }}>
            {question.helpText}
          </div>
        </a>
      )}
    </>
  );
};
export default FlatComponent;
